"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.measurementTagEnums = void 0;
// NMS specific measurement tags are defined here:
// https://github.com/kentik/ranger-config/blob/293c3c00b38bd4f9ed051d9e1f4486ba3236cab1/docs/schema-guide.md#L54
const measurementTagEnums = exports.measurementTagEnums = {
  CUSTOM_SNMP: 'custom_snmp',
  ESSENTIAL: 'essential',
  NMS: 'nms',
  KENTIK_TELEMETRY: 'kentik_telemetry'
};

// Dimension filters will just use the base Filter interface